import React from "react";

/**
 * Marcação de produto promocional — flag `promocional` que vem do ESTOQUE_URL
 * (ERP: `produtoderivacao.pd_promocional`, por filial).
 *
 * A linha inteira ganha cor e o nome do produto recebe o selo, para o atendente
 * reconhecer a promoção sem sair da conversa. Cor e rótulo vivem aqui porque a
 * tabela de produtos tem três variantes (padrão, busca por imagem e Roma) e elas
 * não podem divergir. As cores são as mesmas da listagem de produtos do ERP.
 */
const COR_LINHA = "#fdfdb5";
const COR_SELO = "#E8A33D";

export const estiloLinhaProdutoPromocional = (item) =>
  item && item.promocional ? { backgroundColor: COR_LINHA } : null;

export const TagProdutoPromocional = ({ item }) => {
  if (!item || !item.promocional) return null;
  return (
    <span
      style={{
        backgroundColor: COR_SELO,
        borderRadius: 3,
        color: "#fff",
        fontSize: 10,
        fontWeight: "bold",
        marginLeft: 6,
        padding: "1px 5px",
        whiteSpace: "nowrap",
      }}
    >
      PROMOÇÃO
    </span>
  );
};
